import { Directive } from '@angular/core';

@Directive({
  selector: `input[atInput], select[atInput], textarea[atInput]`,
  exportAs: 'atInput',
  host: {
    'class': 'at-input-element'
  }
})
export class InputDirective {

  constructor() { }

}
